import * as React from 'react'

const SectionDefault = ({ children, maxW = 'max-w-7xl', className = '', isFooter = false }) => {
  const newClassName = `${maxW} mx-auto px-3 md:px-12 xl:px-0 ${className}`

  return React.createElement(isFooter ? 'footer' : 'section', { className: newClassName }, children)
}

export default SectionDefault
